import { string, z } from 'zod'

export type MenuItem = {
      label: string
} & (MenuItemLink | MenuItemSubMenu | MenuItemInternal)

type MenuItemInternal = {
      type: 'internal'
      path: string
      slug?: string
}

type MenuItemLink = {
      type: 'link'
      link: string
}

type MenuItemSubMenu = {
      type: 'menu'
      items: Array<MenuItem>
}

type NavigationItemLink = {
      type: 'link'
      title: string
      url: string
}

const NavigationItemRelationSimple = z.object({
      id: z.union([z.string(), z.number()]),
      title: z.string(),
      slug: z.string(),
})

const NavigationItemRelationComplex = z.object({
      value: NavigationItemRelationSimple,
      relationTo: z.string(),
})

export const NavigationItemInternal = z.object({
      type: z.literal('internal'),
      page: z.union([NavigationItemRelationSimple, NavigationItemRelationComplex]),
      title_override: z.union([z.string(), z.undefined(), z.null()]),
      title: z.any(),
      link: z.any(),
      menu: z.any(),
})

export type NavigationItemInternalType = z.infer<typeof NavigationItemInternal>

const NavigationItemLink = z.object({
      type: z.literal('link'),
      title: z.string(),
      link: z.string(),
      page: z.any(),
      title_override: z.any(),
      menu: z.any(),
})

type NavigationItemLinkType = z.infer<typeof NavigationItemLink>

export const NavigationItemMenu = z.object({
      type: z.literal('menu'),
      title: z.string(),
      page: z.any(),
      title_override: z.any(),
      menu: z.array(z.union([NavigationItemLink, NavigationItemInternal])),
})

type NavigationItemMenuType = z.infer<typeof NavigationItemMenu>

export const NavigationItem = z.union([NavigationItemInternal, NavigationItemLink, NavigationItemMenu])

export type NavigationItemType = z.infer<typeof NavigationItem>
